function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { crudProfilingScore } from '@/mixins/profiling';
import { mapState } from 'vuex';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
export default {
  name: 'ProfilingTableParameters',
  components: {
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  data: function data() {
    return {
      CREATE_MODE: 'create',
      deleted_validation_types: [],
      v_type_selected: '',
      validForm: true
    };
  },
  mixins: [crudProfilingScore],
  props: {
    stateName: {
      type: String,
      required: false,
      default: 'select_profiling_validation_type'
    },
    modalName: {
      type: String,
      required: false,
      default: 'validation Type'
    },
    modalId: {
      type: String,
      required: false,
      default: '/validation_type'
    },
    fields: {
      type: Array,
      required: false,
      default: function _default() {
        return [{
          value: 'name',
          text: 'Name',
          sortable: true,
          class: 'text-left pl-3'
        }, {
          value: 'actions',
          class: 'text-center'
        }];
      }
    },
    dispatchName: {
      type: String,
      required: false,
      default: 'data-platform/getProfilingValidationType'
    },
    title: {
      type: String,
      required: false,
      default: 'Score by validation type'
    },
    deleteValidationType: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['score_field_types', 'select_profiling_validation_type', 'score_table_rules', 'isDomainItc'])), {}, {
    texts: function texts() {
      return {
        name: this.traductor('tablas.name'),
        weight: this.traductor('tablas.weight'),
        field_type: this.traductor('tablas.field_type'),
        table_type: this.traductor('tablas.table_type'),
        lower: this.traductor('tablas.lower'),
        upper: this.traductor('tablas.upper')
      };
    },
    rows: function rows() {
      return this.getItems().length;
    }
  }),
  watch: {
    mode: function mode(value) {
      if (value === this.CREATE_MODE && this.modalId === this.MODAL_PROFILING_VALIDATION_TYPE) {
        this.getDeletedValidationType();
      }
    },
    v_type_selected: function v_type_selected(value) {
      if (value !== '' && this.deleted_validation_types && !this.deleteValidationType) {
        this.record = this.deleted_validation_types.find(function (e) {
          return e.name === value;
        });
      }
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getRecords: function getRecords() {
      var _this = this;
      if (!this.getItems().length) {
        this.toggleBusy();
        this.$store.dispatch(this.dispatchName).then(function () {
          _this.toggleBusy();
        });
      }
    },
    getStateName: function getStateName() {
      return this.stateName;
    },
    getItems: function getItems() {
      if (this.stateName === 'score_field_types') {
        return this.score_field_types;
      } else if (this.stateName === 'score_table_rules') {
        return this.score_table_rules;
      } else if (!this.deleteValidationType) {
        return this.select_profiling_validation_type.filter(function (e) {
          return e.weight > 0;
        });
      }
      return this.select_profiling_validation_type;
    },
    formatter: function formatter(value) {
      return value.toLowerCase();
    },
    onChange: function onChange(event) {
      console.log(event.target.value.name);
    }
  }
};